import { type KmatType } from "~/features/configurator/Linear/kmatType";

export interface LinearConfigurationDTO {
  configId: string;
  designation: string | null;
  description: string | null;
  schaefflerId: string | null;

  kbInfo: string[] | undefined;

  kmats: KmatDTO[];

  cadUrl: string;
  cadXmlRequest: string;

  manufacturerLogo: string | null;
  baseExternalUrl: string;
  mediaUrl: string;

  productCode: string;
  conflictedCstics: ConflictKmatDTO[] | null;
  systemLayoutHelpTile: TileDTO | null;
  minLength: number | null;
  maxLength: number | null;
  allowedSteps: boolean[][];
  complete: boolean | null;
  step5PdfLink: string | null;
  currentStep: number | null;
  highestVisitedStep: number | null;
  guidewayPieceLimits: Dict<{ minLength: number; maxLength: number }>;
  customSegmentLengthSelected: boolean | null;
  specialTranslations: Dict<string> | null;
  resetCarriageDetails: boolean | null;
  configVersion: string | null;
  enableConfigureCarriageValues: boolean | null;
  enableCarriageEdit: boolean[] | undefined;
  priceReference: string;
  largeDesignSelected: boolean | null;

  standardValues: Record<string, string>;
}

export interface KmatDTO {
  id: string;
  parentId?: string;
  cstics: LinearCsticDTO[];
  type: KmatType;
}

export enum SubstepType {
  SystemLayout = "SystemLayout",
  DesignType = "DesignType",
  Size = "Size",
  Preload = "Preload",
  Accuracy = "Accuracy",
  HeightSorting = "HeightSorting",
  LocatingFace = "LocatingFace",
  Length = "Length",
  SystemCoating = "SystemCoating",
  Lubrication = "Lubrication",
  SimpleLubrication = "SimpleLubrication",
  Attachment = "Attachment",
  Closure = "Closure",
  GuidewaySet = "GuidewaySet",
  ReferenceCarriage = "ReferenceCarriage",
  SMDS = "SMDS",
  SMDE = "SMDE",
  CarriageDetails = "CarriageDetails",
  SummaryPage = "SummaryPage",

  // Unit specific
  KLLTGuidewaySet = "KLLTGuidewaySet",
  KLLTCarriageDetails = "KLLTCarriageDetails",
  Sealing = "Sealing",

  // Carriage specific
  Series = "Series",
  CarriageType = "CarriageType",
  ConfigureCarriage = "ConfigureCarriage",

  // Rail specific
  Mounting = "Mounting",
  ConfigureRail = "ConfigureRail",

  // Shaft specific
  Diameter = "Diameter",
  Material = "Material",
  Coating = "Coating",
  Tolerance = "Tolerance",
  ShaftLength = "ShaftLength",
  ShaftTolerance = "ToleranceShaftLength",
  ShaftMachining = "ShaftMachining",
  ShaftMachiningExtra = "ShaftMachiningExtra",
}

export enum SubstepFooterInfoType {
  Message,
  Text,
}

export interface LinearCsticDTO {
  key: string;
  name: string;
  label: string;
  values: LinearCsticValueDTO[];
  type: string;
  info: string;
  description: string;
  value: string;
  readonly: boolean;
}
export interface LinearCsticValueDTO {
  key: string;
  label: string;
  value: string;
  info: string;
  imageUrl: string;
  standard?: boolean;
  defaultValue: boolean;
}
export interface TileDTO {
  label: string;
  imageUrl: string;
  linkUrl: string;
}

export interface ConflictKmatDTO {
  id: string;
  name: string;
  description: string;
  cstics: ConflictCsticDTO[];
}

export type ConflictCsticDTO = Pick<LinearCsticDTO, "key" | "name" | "value"> & { lastValidValue: string };

export interface SavedConfigurationDTO {
  code: string;
  designation: string;
  mediaUrl: string;
  name?: string;
  schaefflerId: string;
  manufacturerUrl: string;
  shortDescription?: string;
  comment?: string;
  /** UI-only/legacy field; the SavedConfigData page body does not emit it. */
  showComment?: boolean;
  importUrlPrefix: string;
  baseExternalUrl: string;
}
